export default {
  G: 'Marchandises',
  P: 'Voyageurs',
  X: 'Isolé',
};
